var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feedback",
    transform: "translate(-765 -575)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_301",
    "data-name": "Ellipse 301",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(765 575)",
    fill: "#004b75",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631",
    transform: "translate(-109.127 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630",
    transform: "translate(892.127 575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M91.612,54.266H116.9a4.559,4.559,0,0,1,4.547,4.547V73.02a4.559,4.559,0,0,1-4.547,4.547h-6.045l-6.6,6.216-6.6-6.216H91.61a4.558,4.558,0,0,1-4.547-4.547V58.813a4.559,4.559,0,0,1,4.547-4.547Zm26.135,9.314-10.866,6.18-4.766-1.31,1.31-4.766,10.865-6.18,3.457,6.077Zm-2.2-.605-1.859-3.267L104.8,64.759l-.7,2.563,2.563.7,8.881-5.051ZM92.605,59.284h7.522V60.9H92.605Zm0,6.254h4.967v1.621H92.605Zm0,6.254h16.132v1.621H92.605Zm24.291-15.9H91.612a2.938,2.938,0,0,0-2.927,2.926V73.022a2.938,2.938,0,0,0,2.927,2.927h6.682l5.96,5.615,5.96-5.615H116.9a2.938,2.938,0,0,0,2.927-2.927V58.815a2.937,2.937,0,0,0-2.927-2.926Z",
    transform: "translate(-87.063 -54.266)",
    fill: "#004c75",
    stroke: "#f2f6f8",
    strokeWidth: 0.6
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.a11579aa2c638663149c51e1272fa1da.svg";
export { ForwardRef as ReactComponent };